function loadDesigners(){var i="abcdefghijklmnopqrstuvwxyz".split("");var t=$("#vendors");var n="";$.each(i,(function(){t.find("."+this.toUpperCase()).length>0&&(n=(n='<div class="vendors-group">')+"<h3>"+this.toUpperCase()+"</h3>",n+="<ul/>",$("#vendors ."+this.toUpperCase()).each((function(){n=n+"<li>"+$(this).html()+"</li>"})),n+="</ul>",n+="</div>",$(".vendors").append(n))}))}$(document).ready((function(){loadDesigners(),$(document).on("click",'.collection-quick-add',(function(i){if(!$(this).hasClass("disabled")){var t=$(this).parents(".quick-add-box"),n=$(this).data("id");t.find('input[name="id"]').removeAttr("checked"),t.find("input[name='id'][value='"+n+"']").prop("checked",!0),t.find(".button--add-to-cart").trigger("click")}})),$(".product-accordion__list").length>0&&$(".product-accordion__list li").each((function(){$(this).on("click",(function(){$(this).toggleClass("active")}))})),$(".popup-custom__close").on("click",(function(){$(".popup-image-custom").hide()}))}));
//# sourceMappingURL=/s/files/1/1292/7479/t/19/assets/custom.js.map?v=1633249011

$( document ).ready(function() {
  // Mobile Menu - Arrow Switcher
  $('.mega-menu-mobile-arrow').on('click', function() {
      var parent = $(this).parents('.menu__heading');
      parent.toggleClass('active');
      parent.siblings('ul').toggleClass('active');
  });

  // Ajax Continue Shopping
  $('body').on('click', '.ajax-continue', function(){
    $('[data-ajax-cart-close]').click();
  }); 

  // Mobile Menu Update
  $('.submenu__input').change(function(){
    if( $(this).is(":checked") ) {
      $('.submenu__input').prop('checked', false);
      $(this).prop('checked', true);
    }
  });

  // Filter Mobile Toggle
  $('.mobile_filter_button').on('click', function(){
    $('.faceted-filter-form').slideToggle();
  });

  // Wishlist Swatch Options
  $(".swatch__option").mouseover(function(){
    $(".swatch .swatch__option input").removeAttr("disabled");
  });

  // Cart Upsell Slider
  $('body').on('click', '.flickity-button.previous', function(){
    var current_index = $('body').find('.upsell_slider .upsell.active').data('index'),
        max_index = $('body').find('.upsell_slider .upsell').last().data('index');

    if( current_index == 1 ) {
      current_index = max_index;
    } else {
      current_index -= 1; 
    }

    $('body').find('.upsell_slider .upsell').removeClass('active');
    $('body').find('.upsell_slider .upsell[data-index="' + current_index + '"]').addClass('active');

  });

  $('body').on('click', '.flickity-button.next', function(){
    var current_index = $('body').find('.upsell_slider .upsell.active').data('index'),
        max_index = $('body').find('.upsell_slider .upsell').last().data('index');

    if( current_index == max_index ) {
      current_index = 1;
    } else {
      current_index += 1; 
    }

    $('body').find('.upsell_slider .upsell').removeClass('active');
    $('body').find('.upsell_slider .upsell[data-index="' + current_index + '"]').addClass('active');

  });

  var href = window.location.href;
  setTimeout(() => {
    console.log("hello")
    window.history.replaceState({}, '', window.location.href.split("?variant")[0]);
  }, 500);
  
});